import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BlogHeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export default function BlogHeader({
  searchQuery,
  onSearchChange,
}: BlogHeaderProps) {
  const { t } = useTranslation();
  return (
    <>
      <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center justify-center overflow-hidden pt-20">
        <img
          src="https://readdy.ai/api/search-image?query=Travel%20journalist%20writing%20notes%20in%20a%20leather%20notebook%20on%20a%20wooden%20table%20beside%20a%20window%20overlooking%20a%20scenic%20Vietnamese%20landscape%20with%20emerald%20rice%20terraces%20and%20limestone%20mountains%2C%20warm%20natural%20light%2C%20cozy%20storytelling%20atmosphere%2C%20editorial%20photography%20with%20soft%20shadows%2C%20high%20detail&width=1800&height=900&seq=blog-hero-bg&orientation=landscape"
          alt={t('blog.heroAlt')}
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />

        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
          <p className="text-accent-400 text-sm md:text-base tracking-wide uppercase mb-3">
            {t('blog.eyebrow')}
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
            {t('blog.title')}
          </h1>
          <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            {t('blog.subtitle')}
          </p>

          <nav className="mt-8 flex items-center justify-center gap-2 text-sm text-white/70">
            <Link to="/" className="hover:text-white transition-colors">{t('blog.home')}</Link>
            <span>/</span>
            <span className="text-white">{t('blog.blog')}</span>
          </nav>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1200px] px-4 py-6 sm:px-6 lg:px-6">
        <div className="flex w-full justify-end">
          <div className="relative min-w-0 flex-1 sm:w-[280px] sm:flex-none">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-secondary-400 text-sm" />
            <input
              type="search"
              placeholder={t('blog.searchPlaceholder')}
              aria-label={t('blog.searchAria')}
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="h-[46px] w-full rounded-full border border-secondary-200 bg-white pl-11 pr-4 text-[13.5px] text-secondary-900 placeholder:text-secondary-400 outline-none transition-colors focus:border-primary-500 focus:ring-4 focus:ring-primary-500/15"
            />
          </div>
        </div>
      </section>
    </>
  );
}